import { styled } from '@ltvco/refresh-lib/theme';

const CHATGPT_GREEN = '#74AA9C';

export const ChatGptBadge = styled('div', {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size: number }>(({ size }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: size,
  height: size,
  borderRadius: Math.round(size * 0.27),
  backgroundColor: CHATGPT_GREEN,
}));

export const IconBox = styled('div')(({ theme }) => ({
  display: 'flex',
  flexShrink: 0,
  color: theme.palette.text.primary,
}));
